import React from "react";
import { Form, Select } from "antd";
import transportFieldsConnect from "../../../common/hoc/transportFieldsConnect";
const VehicleTypes = ({ form, disabled, vehicleTypes }) => {
  const { getFieldDecorator } = form;
  const handleChange = val => {
    if (val && form.getFieldError("vehicleType")) {
      form.setFieldsValue({ vehicleType: val });
    }
  };
  return (
    <>
      <span className="label">Тип ТС:</span>
      <Form.Item>
        {getFieldDecorator("vehicleType")(
          <Select
            placeholder="Выберите тип ТС"
            className="basicInput"
            style={{ width: 224 }}
            disabled={disabled}
            onChange={handleChange}
            showSearch
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            getPopupContainer={trigger => trigger.parentNode}
          >
            {vehicleTypes &&
              vehicleTypes.map((item, index) => (
                <Select.Option
                  value={item.vehicleTypeId}
                  key={item.vehicleTypeId}
                >
                  {item.vehicleType}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </>
  );
};

export default transportFieldsConnect(VehicleTypes, ["vehicleTypes"]);
